import React, { useState } from 'react';
import styled from 'styled-components';
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

const PasswordInputContainer = styled.div`
    position: relative;
    width: 100%;
`;

const Input = styled.input`
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.08);
    padding: 0.7rem 2.5rem 0.7rem 1rem;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.9rem;
    font-family: 'Poppins', sans-serif;
    transition: border-color 0.2s, background 0.2s;

    &::placeholder { color: rgba(255, 255, 255, 0.3); }
    &:focus {
        outline: none;
        border-color: rgba(99, 102, 241, 0.5);
        background: rgba(255, 255, 255, 0.08);
    }
`;

const PasswordToggleIcon = styled.span`
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
    color: rgba(255, 255, 255, 0.3);
    font-size: 1.3rem;
    display: flex;
    transition: color 0.2s;

    &:hover { color: rgba(255, 255, 255, 0.6); }
`;

const PasswordField = ({ placeholder, reference, ...rest }) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <PasswordInputContainer>
            <Input
                type={showPassword ? "text" : "password"}
                placeholder={placeholder}
                ref={reference}
                {...rest}
            />
            <PasswordToggleIcon onClick={() => setShowPassword(prev => !prev)}>
                {showPassword ? <MdVisibilityOff size={22} /> : <MdVisibility size={22} />}
            </PasswordToggleIcon>
        </PasswordInputContainer>
    );
};

export default PasswordField;
